import { useCallback } from 'react';
import { FastFieldProps } from 'formik';

import { chain, setIn } from '@lyearn/core/utils/immutable';

// also use TValues
const useRendererFunctions = <TValue extends any = any>({
  name,
  setFieldValue,
  setStatus,
  status,
}: {
  name: string;
  setFieldValue: FastFieldProps<TValue>['form']['setFieldValue'];
  setStatus: FastFieldProps<TValue>['form']['setStatus'];
  status: FastFieldProps<TValue>['form']['status'];
}) => {
  const onChange = useCallback(
    (nextValue: TValue) => {
      setFieldValue(name, nextValue, true);
    },
    [name, setFieldValue],
  );

  const setErrorElement = useCallback(
    (element: HTMLElement | null) => {
      setStatus(setIn(status ?? {}, `errorElements.${name}`, element));
    },
    [name, setStatus, status],
  );

  const setNudgeState = useCallback(
    (fieldName: string, value: string) => {
      setStatus(
        chain(status ?? {})
          .setIn(`nudge.${fieldName}`, value)
          .setIn('scrollToNudge', true)
          .value(),
      );
    },
    [setStatus, status],
  );

  return {
    onChange,
    setErrorElement,
    setNudgeState,
  };
};

export default useRendererFunctions;
